export default __webpack_public_path__ + "static/media/io-concept.43bca057.gif";